import React from "react";
import { ListTableColumn, createListTableColumns, renderBooleanIcon } from "sprint-common-web";

import { mapAirlinesToDisplay } from "../../../common/utils/mapAirlinesToDisplay";
import { renderBuzzItem } from "../../common/components/BuzzItem";
import { renderContentSource } from "../../common/utils/renderContentSources";
import { AncillaryItem } from "./AncillaryItem";
import { AddAncillaryToMergeButton } from "./buttons/AddAncillaryToMergeButton";
import { EditAncillaryButton } from "./buttons/EditAncillaryButton";
import { ViewAncillaryAssetButton } from "./buttons/ViewAncillaryAssetButton";

export const createAncillaryListingColumns = (): ListTableColumn<AncillaryItem>[] => {
    return createListTableColumns<AncillaryItem>([
        {
            type: "basic",
            key: "title",
            name: "Title",
            minWidth: 100,
            maxWidth: 280,
            isSortable: true
        },
        {
            type: "basic",
            key: "merged",
            name: "Merged",
            minWidth: 70,
            maxWidth: 70,
            isSortable: false,
            onRender: renderBooleanIcon
        },
        {
            type: "basic",
            key: "source",
            name: "Source",
            minWidth: 120,
            maxWidth: 160,
            isSortable: false,
            onRender: renderContentSource
        },
        {
            type: "basic",
            key: "airlines",
            name: "Airlines",
            minWidth: 100,
            maxWidth: 280,
            isSortable: false,
            isMultiline: true,
            onRender: renderAirlines
        },
        {
            type: "basic",
            key: "versionType",
            name: "Version Type",
            minWidth: 100,
            maxWidth: 280,
            isSortable: false,
            onRender: renderVersionType
        },
        {
            type: "basic",
            key: "distributor",
            name: "Distributor",
            minWidth: 75,
            maxWidth: 280,
            isSortable: false,
            onRender: renderDistributor
        },

        {
            type: "basic",
            key: "buzz",
            name: "Source details",
            minWidth: 120,
            maxWidth: 500,
            isSortable: false,
            onRender: (item) => {
                return renderBuzzItem(item?.buzz);
            }
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 96,
            maxWidth: 96,
            buttons: [
                {
                    id: "edit",
                    isDisabled: (item) => !!item.buzz?.id,
                    render: EditAncillaryButton
                },
                {
                    id: "merge",
                    render: AddAncillaryToMergeButton
                },
                {
                    id: "viewAssets",
                    render: ViewAncillaryAssetButton
                }
            ]
        }
    ]);
};

const renderAirlines = (item: AncillaryItem) => {
    const airlines = mapAirlinesToDisplay(item.airlines);

    return <>{airlines}</>;
};

const renderVersionType = (item: AncillaryItem) => {
    return <>{item.versionType.name}</>;
};

const renderDistributor = (item: AncillaryItem) => {
    return <>{item.distributor?.name}</>;
};
